module.exports = __webpack_public_path__ + "assets/img/kv-2e822c2d.jpg";